import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const careerSubCategories = `${REACT_APP_API_PREFIX}/${service}/careerSubCategories`;

export function getCareerSubCategories(filters) {
  const url = `${careerSubCategories}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getCareerSubCategoryById(id) {
  const url = `${careerSubCategories}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateCareerSubCategory(id, body) {
  const url = `${careerSubCategories}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteCareerSubCategory(id) {
  const url = `${careerSubCategories}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createCareerSubCategory(body) {
  const url = `${careerSubCategories}`;
  return {
    method: POST,
    url,
    body,
  };
}
